import { render } from "./DictionaryList.vue?vue&type=template&id=690a00f2&scoped=true"
import script from "./DictionaryList.vue?vue&type=script&lang=js"
export * from "./DictionaryList.vue?vue&type=script&lang=js"

import "./DictionaryList.vue?vue&type=style&index=0&id=690a00f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690a00f2"]])

export default __exports__